module.exports = __webpack_public_path__ + "static/media/Logo__FCA.db2e1096.svg";